import { render, staticRenderFns } from "./solution-card.vue?vue&type=template&id=533f9666&scoped=true&"
import script from "./solution-card.vue?vue&type=script&lang=js&"
export * from "./solution-card.vue?vue&type=script&lang=js&"
import style0 from "./solution-card.vue?vue&type=style&index=0&id=533f9666&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f9666",
  null
  
)

export default component.exports